module.exports = __webpack_public_path__ + "img/ifo_logo.279469f2.png";